import { Radio, Stack } from '@mui/joy';
import { SyntheticEvent } from 'react';
import { useTranslation } from 'react-i18next';

import { DefaultPricingType } from 'contacts/enums';
import { FormField } from 'core/components';
import { InputType } from 'core/enums';
import { useFormContext } from 'core/states';
import { Direction, Size } from 'theme/enums';

export const DefaultPricingFormField = () => {
  const { t } = useTranslation();

  const { control, errors, watch, setValue } = useFormContext();

  const defaultPricingValue = watch('defaultPricing');

  const onDefaultPricingChange = (event: SyntheticEvent) => {
    const value = (event.target as HTMLInputElement).value;

    setValue(
      value === DefaultPricingType.BASE_MARGIN
        ? DefaultPricingType.BASE_DISCOUNT
        : DefaultPricingType.BASE_MARGIN,
      null
    );
  };

  return (
    <FormField
      name="defaultPricing"
      type={InputType.RADIO_GROUP}
      inputProps={{
        control,
        error: errors['defaultPricing'],
        label: t('labelDefaultPricing'),
        labelSxProps: {
          fontSize: '16px !important',
          fontWeight: 500,
          marginBottom: 0,
        },
        renderRadio: (choice) => {
          const isChoiceSelected = defaultPricingValue === choice.value;

          return (
            <Stack
              key={choice.value}
              direction={Direction.ROW}
              sx={{
                alignItems: 'center',
                height: '32px',
                gap: 1,
              }}
            >
              <Radio
                size={Size.SM}
                value={choice.value}
                label={choice.label}
                onChange={onDefaultPricingChange}
                sx={{ minWidth: '150px' }}
              />

              <FormField
                name={`${choice.value}`}
                type={InputType.NUMBER_INPUT}
                inputProps={{
                  control,
                  error: errors[`${choice.value}`],
                  placeholder: choice.label,
                  slotProps: choice.slotProps,
                  disabled: !isChoiceSelected,
                }}
              />
            </Stack>
          );
        },
        choices: [
          {
            label: t('labelBaseMargin'),
            value: DefaultPricingType.BASE_MARGIN,
            slotProps: {
              input: {
                decimalScale: 2,
                suffix: '%',
              },
            },
          },
          {
            label: t('labelBaseDiscount'),
            value: DefaultPricingType.BASE_DISCOUNT,
            slotProps: {
              input: {
                decimalScale: 2,
                suffix: '%',
              },
            },
          },
        ],
      }}
    />
  );
};
